import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogRef, MatDialogContent, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio'
import { PreMatriculaService } from '../../services/pre-matricula.service';
import { PreMatricula } from '../../shared/models/pre-matricula.model';
import { CommonModule } from '@angular/common';
import { CepService } from '../../services/cep.service';
import { HttpErrorResponse } from '@angular/common/http';
import { InfoDialogComponent } from '../../core/info-dialog/info-dialog.component';
import { StatusCard } from "../../shared/components/status-card/status-card";
import { MatSnackBar } from '@angular/material/snack-bar';
import { UfService } from '../../services/uf.service';
import { MunicipioService } from '../../services/municipio.service';
import { PaisService } from '../../services/pais.service';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { environment } from '../../../environments/environment';
import { RequiredFieldDirective } from '../../shared/directives/required-fields-directive';
import { UtilsService } from '../../services/utils.service';
import { StepperSelectionEvent } from '@angular/cdk/stepper';

export interface DialogData {
  alunoId: number;
  anoLetivoId: number;
  anoLetivo: string;
}

@Component({
  selector: 'app-prematricula-wizard',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatDialogContent,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatRadioModule,
    StatusCard,
    MatCheckboxModule,
    RequiredFieldDirective,
],
  templateUrl: './prematricula-wizard.html',
  styleUrl: './prematricula-wizard.scss',
})
export class PrematriculaWizard {

  @ViewChild('getNetButton')
  getNetButton!: ElementRef;

  @ViewChild(MatStepper) stepper!: MatStepper;
  @ViewChild('stepMatricula') stepMatricula!: any;

  maximizado: boolean = true;
  preMatriculaForm!: FormGroup;
  matriculas: any[] = [];
  turmas: any[] = [];
  turmaPrecos: any[] = [];
  turma: any = {};
  turmaPrecoPadrao: any[] = [];
  turmaPreco: any = {};
  temPrecosRematricula: boolean = true;
  dadosMatriculaPreenchidos: boolean = false;
  dadosCobrancaPreenchidos: boolean = false;
  cepString: string = "";
  cepPesquisado: any = {}
  matriculaTurmaPrecoCondicaoPagamentos: any = [];
  mensalidadeTurmaPrecoCondicaoPagamentos: any = [];
  materialDidaticoTurmaPrecoCondicaoPagamentos: any = [];
  totalDesconto: number = 0;
  turmaPrecoOficial: any = {
    valorMatricula: 0,
    ValorMensalidade: 0
  };
  pagamentoMensalidadeSelecionado = false;
  pagamentoMaterialDidaticoSelecionado = false;
  pagamentoMatriculaSelecionado = false;

  mensalidadeFinalParcela: number = 0;
  mensalidadeParcelaPeriodo: number = 0;
  qtdeParcelasMensalidadeSelecionada: number = 0;
  descontoMensalidade: number = 0;
  totalMensalidade: number = 0;
  percentualDescontoMensalidade: string = '0%';
  percentualAumentoMensalidade: string = '0%'

  materialDidaticoFinalParcela: number = 0;
  materialDidaticoParcela: number = 0;
  qtdeParcelasMaterialDidaticoSelecionada: number = 0;
  totalMaterialDidatico: number = 0;
  descontoMaterialDidatico: number = 0;
  percentualDescontoMaterialDidatico: string = '0%';

  matriculaFinalParcela: number = 0
  matriculaParcela: number = 0;
  qtdeParcelasMatriculaSelecionada: number = 0;
  totalMatricula: number = 0;
  descontoMatricula: number = 0;
  percentualDescontoMatricula: string = '0%';

  titularTexto: string = "Titular do Cartão";
  ufs: any = [];
  municipios: any = [];
  paises: any = [];

  apiGetNet: any = {
    orderid: 1
  };
  getNetSellerId = '';
  getNetScript = '';

  preMatricula: PreMatricula = new PreMatricula();
  processoFinalizado: boolean = false;
  isLoading: boolean = false;

  // Desabilitando opções de pagamento relacionadas a PIX e DEBIto
  contaParcelaCondicoesPagamentoDesabilitados = [1, 11];

  // Component logic goes here
  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<PrematriculaWizard>,
    private _formBuilder: FormBuilder,
    private renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public IRematricula: DialogData,
    private preMatriculaService: PreMatriculaService,
    private cepService: CepService,
    private ufService: UfService,
    private municipioService: MunicipioService,
    private paisService: PaisService,
    private utilsService: UtilsService
  ) {
    // Initialization code if needed
  }

  ngOnInit() {
    this.getNetSellerId = environment.getNetSellerId;
    this.getNetScript = environment.getNetScript;

    this.buscarTurmas();
    this.buscarUfs();
    this.buscarPaises();

    this.preMatriculaForm = this._formBuilder.group({
      ...new PreMatricula(),
      turmaSelecionada: new FormControl(null, Validators.required),
      turmaPrecoSelecionado: new FormControl(null, Validators.required),
      paisSelecionado: new FormControl(null, Validators.required),
      ufSelecionada: new FormControl(null),
      municipioSelecionado: new FormControl(null),
      ciente: new FormControl(false, Validators.required),
      condicaoPagamentoId: new FormControl(0, Validators.required),
    });

    //Setando alunoId e ano letivo no form
    this.preMatriculaForm.get('alunoId')?.setValue(this.IRematricula.alunoId);
    this.preMatriculaForm.get('anoLetivoId')?.setValue(this.IRematricula.anoLetivoId);

    // Depois de criar o form, você pode adicionar os controles que quiser:
    this.preMatriculaForm.get('pagadorCpf')?.setValidators([Validators.required, this.utilsService.cpfValidator()]);
    this.preMatriculaForm.get('pagadorCep')?.setValidators([this.utilsService.cepValidator()]);
    this.preMatriculaForm.addControl('pagadorNome', new FormControl(null, Validators.required));
    this.preMatriculaForm.addControl('pagadorEmail', new FormControl(null, [Validators.required, Validators.email]));
    this.preMatriculaForm.addControl('pagadorLogradouro', new FormControl(null, Validators.required));
    this.preMatriculaForm.addControl('pagadorBairro', new FormControl(null, Validators.required));
    this.preMatriculaForm.addControl('pagadorCep', new FormControl('')); // aceita vazio ou apenas numeros
    this.preMatriculaForm.addControl('pagadorLogradouroNumero', new FormControl(''));
    this.preMatriculaForm.addControl('pagadorLogradouroComplemento', new FormControl(''));
    this.preMatriculaForm.addControl('pagadorUf', new FormControl(''));
    this.preMatriculaForm.addControl('pagadorMunicipio', new FormControl(''));

    // this.preMatriculaForm.updateValueAndValidity();

    this.onChanges();

  }

  onChanges() {
    this.preMatriculaForm.get('turmaSelecionada')?.valueChanges.subscribe(selecao => {
      this.preMatriculaForm.get('turmaPrecoSelecionado')?.setValue(null);
    });

    this.preMatriculaForm.get('turmaPrecoSelecionado')?.valueChanges.subscribe(selecao => {
      if(selecao !== null){
        this.dadosMatriculaPreenchidos = true
        // calcula preços de mensalidade, material didatico e matricula com base em periodo/ turmaprecoescolhido
        this.modalidadeTurmaPrecoSelecionada();

        // valida se valor da matricula for 0, libera condicao pagamento
        const condicaoPagamentoControl = this.preMatriculaForm.get('condicaoPagamentoId');
        if(this.turmaPreco.valorMatricula === 0){
          condicaoPagamentoControl?.clearValidators();
        } else {
          condicaoPagamentoControl?.setValidators([Validators.required, this.utilsService.aboveZeroValidator()]);
        }
        condicaoPagamentoControl?.updateValueAndValidity();

      }
    });

    this.preMatriculaForm.get('pagadorCep')?.valueChanges.subscribe(data => {
      const cep = this.filtraApenasNumeros(data)
      if(cep.length === 8){
        this.consultaCep(cep);
      }
    });

    this.preMatriculaForm.get('formaDePagamentoMatricula')?.valueChanges.subscribe(data => {
      if(this.textoContaParcelaTipoPagamento(data) === "Boleto") {
        this.titularTexto = "Pagador do Boleto"
      } else {
        this.titularTexto = "Titular do Cartão"
      }
    });



    this.preMatriculaForm.get('paisSelecionado')?.valueChanges.subscribe(data => {

      if(data.paisId !== 30) {
        this.preMatriculaForm.get('ufSelecionada')?.setValue(null);
        this.preMatriculaForm.get('municipioSelecionado')?.setValue(null);
        this.preMatriculaForm.get('pagadorCep')?.setValue(null);

        this.preMatriculaForm.get('ufSelecionada')?.disable();
        this.preMatriculaForm.get('municipioSelecionado')?.disable();
        this.preMatriculaForm.get('pagadorCep')?.disable();
      } else {
        this.preMatriculaForm.get('ufSelecionada')?.enable();
        this.preMatriculaForm.get('municipioSelecionado')?.enable();
        this.preMatriculaForm.get('pagadorCep')?.enable();
      }

      this.preMatriculaForm.get('pagadorPaisId')?.setValue(data.paisId);
      this.preMatriculaForm.get('pagadorPais')?.setValue(data.descPais);

    });


    this.preMatriculaForm.get('ufSelecionada')?.valueChanges.subscribe(data => {
        this.preMatriculaForm.get('pagadorUfId')?.setValue(data?.ufId);
        this.preMatriculaForm.get('pagadorUf')?.setValue(data?.siglaUF);

        // if(data !== null)
        this.buscarMunicipioPorUf(data?.ufId);
    });

  }

  onStepChange(event: StepperSelectionEvent) {

    if (event.selectedStep === this.stepMatricula) {
      this.aoEntrarStepMatricula();
    }
  }

  aoEntrarStepMatricula() {
    if(this.turmaPreco.matriculaDesabilitarCobranca || this.turmaPreco.valorMatricula == 0){
      this.preenchePagadorComDadosResponsavelFinanceiro();
    }
  }

  restaurarDialog() {
    let innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
        this.dialogRef.updateSize('90%', '100vh');
        this.dialogRef.updatePosition();
    }
    else {
        this.dialogRef.updateSize('60%', '100vh');
        this.dialogRef.updatePosition();
    }
    this.maximizado = false;
  }

  maximizarDialog() {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  fecharDialog() {
    this.dialogRef.close();
  }

  buscarTurmas() {
    // Simulação de dados de turmas
    this.preMatriculaService.buscarTurmasDisponiveis(this.IRematricula.alunoId, this.IRematricula.anoLetivoId).subscribe((response) => {
      this.turmas = response.body.turmasDisponiveis;
      this.matriculas = response.body.matriculas;
    });

  }

  buscarPaises(){
    this.paisService.getPaises().subscribe((response) => {
      this.paises = response.body;

      // define brasil com pais padrao
      this.determinaPaisPadrao();
    })
  }

  determinaPaisPadrao() {
    const paisPadrao = this.procuraPaisPorId(30);
      this.preMatriculaForm.get('paisSelecionado')?.setValue(paisPadrao);
  }

  procuraPaisPorId(id: number) {
    return this.paises.find((pais: any) => pais.paisId === id);
  }

  buscarUfs() {
    this.ufService.getUFs().subscribe((response) => {
      this.ufs = response.body;
    })
  }

  buscarMunicipioPorUf(ufId: number) {
    if (ufId > 0) {

      this.municipioService.getMunicipioPorUf(ufId).subscribe(data => {
        this.municipios = data.body;

        let municipiosTemp = data.body;

        if (this.cepPesquisado.ibge > 0) {

          let municipioSelecionado = municipiosTemp.find((municipioTemp: any) => municipioTemp.codIBGE == this.cepPesquisado.ibge);
          this.preMatriculaForm.get('pagadorMunicipioId')?.setValue(municipioSelecionado.municipioId);
          this.preMatriculaForm.get('pagadorMunicipio')?.setValue(municipioSelecionado.descricao);
          this.preMatriculaForm.get('municipioSelecionado')?.setValue(municipioSelecionado);

          if(this.preMatriculaForm.get('pagadorPaisId')?.value !== 30){
            this.determinaPaisPadrao();
          }
        }

      });

    }
  }

  determinaTurma() {
    this.turmaPrecos = [];
    this.turma = this.preMatriculaForm.get('turmaSelecionada')?.value;
    let _turmaPrecos = this.turma.turmaPrecos;

    _turmaPrecos.forEach((turmaPreco: any) => {

      if(turmaPreco.turmaPrecoTipo === 0){
        this.turmaPrecoPadrao.push(turmaPreco);

      } else if (turmaPreco.turmaPrecoTipo === 1) {
        if (turmaPreco.aumentoRematriculaPorPorcentagem){
          let percentualAumentoRematricula = (turmaPreco.percentualAumentoRematricula / 100) + 1;

          let alunoMatricula = this.buscaTurmaMatricula();

          turmaPreco.ValorMensalidade = (alunoMatricula.valorParcelasMensalidade * turmaPreco.numParcelasMensalidade) * percentualAumentoRematricula;
        }

        this.turmaPrecos.push(turmaPreco);
      }
    })

    this.preMatriculaForm.get('turmaId')!.setValue(this.turma.turmaId);

    if(this.turmaPrecos.length == 0){
      this.temPrecosRematricula = false;
    }else{
      this.temPrecosRematricula = true;
    }

  }

  // procura a matricula do aluno para aquela turma
  buscaTurmaMatricula() {
    const matricula = this.matriculas.find((matricula: any) => {
      return matricula.alunoId === this.IRematricula.alunoId
    })
    return matricula;
  }

  consultaCep(valor: any) {
    if (valor != undefined) {

      this.cepService.consultarCep(valor).subscribe(data => {

        this.preMatriculaForm.get('pagadorLogradouro')?.setValue(data.logradouro);
        this.preMatriculaForm.get('pagadorBairro')?.setValue(data.bairro);
        let uf = this.ufs.find((ufTemp: any) => ufTemp.siglaUF == data.uf);
        this.cepPesquisado = data;
        this.preMatriculaForm.get('ufSelecionada')?.setValue(uf);

      });
      // }, (error: HttpErrorResponse) => {
      //   const dialogRef = this.dialog.open(InfoDialogComponent, {
      //     data: {
      //       titulo: "Erro",
      //       erro: "Erro ao consultar CEP, preencha o endereço manualmente"
      //     }
      //   });
      // });
    }
  }

  modalidadeTurmaPrecoSelecionada() {
    this.turmaPreco = this.preMatriculaForm.get('turmaPrecoSelecionado')?.value;

    this.matriculaTurmaPrecoCondicaoPagamentos = [];
    this.mensalidadeTurmaPrecoCondicaoPagamentos = [];
    this.materialDidaticoTurmaPrecoCondicaoPagamentos = [];

    this.preMatriculaForm.get('periodo')?.setValue(this.turmaPreco.periodo);
    this.preMatriculaForm.get('turmaPrecoId')?.setValue(this.turmaPreco.turmaPrecoId);

    //filtro de opções de pagamento que serão exibidas
    let turmaPrecoCondicoesPagamentos =
      this.turmaPreco.turmaPrecoCondicaoPagamentos.filter((c: any) =>
        !this.contaParcelaCondicoesPagamentoDesabilitados.includes(c.contaParcelaTipoPagamento)
      );

    turmaPrecoCondicoesPagamentos.forEach((turmaPrecoCondicoesPagamento: { ativa: boolean; indicadorPagamento: number; parcelasMaximas: number; valorParcela: number; turmaPrecoCondicaoPagamentoModalidade: number; desconto: number; valorComDesconto: number }) => {

      if (turmaPrecoCondicoesPagamento.ativa) {

        let valorASerCalculado = 0;

        switch (turmaPrecoCondicoesPagamento.turmaPrecoCondicaoPagamentoModalidade) {
            case 0:
                valorASerCalculado = this.turmaPreco.valorMatricula;
                break;
            case 1:
                valorASerCalculado = this.turmaPreco.valorMensalidade;
                break;
            case 2:
                valorASerCalculado = this.turmaPreco.valorMaterialDidatico;
                break;
        }

        if(turmaPrecoCondicoesPagamento.desconto > 0)
        {
            turmaPrecoCondicoesPagamento.valorComDesconto = valorASerCalculado * (turmaPrecoCondicoesPagamento.desconto / 100);
            turmaPrecoCondicoesPagamento.valorParcela = (valorASerCalculado - turmaPrecoCondicoesPagamento.valorComDesconto) / turmaPrecoCondicoesPagamento.parcelasMaximas;

        }else{
            turmaPrecoCondicoesPagamento.valorParcela = valorASerCalculado / turmaPrecoCondicoesPagamento.parcelasMaximas;
            turmaPrecoCondicoesPagamento.valorComDesconto = 0;
        }



        switch (turmaPrecoCondicoesPagamento.turmaPrecoCondicaoPagamentoModalidade) {
          case 0:
            if(turmaPrecoCondicoesPagamento.valorParcela != Infinity){
              this.matriculaTurmaPrecoCondicaoPagamentos.push(turmaPrecoCondicoesPagamento);
            }
            break;
          case 1:
            this.mensalidadeTurmaPrecoCondicaoPagamentos.push(turmaPrecoCondicoesPagamento);
            break;
          case 2:
            this.materialDidaticoTurmaPrecoCondicaoPagamentos.push(turmaPrecoCondicoesPagamento);
            break;
        }

      }

    });

    this.turmaPrecoPadrao.forEach(precoPadrao => {
      if(precoPadrao.periodo == this.turmaPreco.periodo){
        this.turmaPrecoOficial = precoPadrao;
        this.totalDesconto = this.turmaPrecoOficial.valorMatricula + this.turmaPrecoOficial.valorMensalidade - this.turmaPreco.valorMatricula - this.turmaPreco.valorMensalidade;
      }
    });

  }

  textoContaParcelaTipoPagamento(contaParcelaTipoPagamento: number) {
    let texto = '';

    switch (contaParcelaTipoPagamento) {
        case 1:
            texto = 'Débito';
            break;
        case 2:
            texto = 'Crédito';
            break;
        case 3:
            texto = 'Boleto';
            break;
        case 4:
            texto = 'Transferência';
            break;
        case 11:
            texto = 'PIX';
            break;
    }

    return texto;
  }

  // calcula pagamento dependendo do tipo (mensalidade, matricula ou materia didatico)
  calculaPagamentoValores(event: any) {
    let pagamentoSelecionado = event.value;


    // 0 - matricula (rematricula) , 1 - Mensalidade , 2 - Material Didatico
    switch (pagamentoSelecionado.turmaPrecoCondicaoPagamentoModalidade) {
      case 0:
        this.pagamentoMatriculaSelecionado = true;
        this.matriculaFinalParcela = pagamentoSelecionado.valorParcela;
        this.descontoMatricula = pagamentoSelecionado.valorComDesconto;
        this.matriculaParcela = ((this.matriculaFinalParcela * pagamentoSelecionado.parcelasMaximas) + this.descontoMatricula) / pagamentoSelecionado.parcelasMaximas;
        this.percentualDescontoMatricula = `${pagamentoSelecionado.desconto}%`;
        this.qtdeParcelasMatriculaSelecionada = pagamentoSelecionado.parcelasMaximas;
        this.totalMatricula = pagamentoSelecionado.parcelasMaximas * pagamentoSelecionado.valorParcela;

        this.preMatriculaForm.get('valorMatricula')?.setValue(this.totalMatricula);
        this.preMatriculaForm.get('numParcelasMatricula')?.setValue(pagamentoSelecionado.parcelasMaximas);
        this.preMatriculaForm.get('valorParcelasMatricula')?.setValue(pagamentoSelecionado.valorParcela);
        this.preMatriculaForm.get('formaDePagamentoMatricula')?.setValue(pagamentoSelecionado.contaParcelaTipoPagamento);

        this.preMatriculaForm.get('condicaoPagamentoId')?.setValue(pagamentoSelecionado.turmaPrecoCondicaoPagamentoId); // acho que e da matricula


        break;
      case 1:
        // seta indica que mensalidade foi selecionada e faz os calculos
        // obs: Valor da parcela já esta com o valor final de cada parcela
        // e valor com desconto é apenas o valor do desconto
        // para calculo da parcela do periodo sem o desconto é feito o "recalculo"
        this.pagamentoMensalidadeSelecionado = true;
        this.mensalidadeFinalParcela = pagamentoSelecionado.valorParcela;
        this.descontoMensalidade = pagamentoSelecionado.valorComDesconto;
        this.mensalidadeParcelaPeriodo = ((this.mensalidadeFinalParcela * pagamentoSelecionado.parcelasMaximas) + this.descontoMensalidade) / pagamentoSelecionado.parcelasMaximas;
        this.percentualDescontoMensalidade = `${pagamentoSelecionado.desconto}%`;
        this.qtdeParcelasMensalidadeSelecionada = pagamentoSelecionado.parcelasMaximas;
        this.totalMensalidade = pagamentoSelecionado.parcelasMaximas * pagamentoSelecionado.valorParcela;

        this.percentualAumentoMensalidade = `${this.turmaPreco.percentualAumentoRematricula - pagamentoSelecionado.desconto}%`;

        this.preMatriculaForm.get('totalMensalidade')?.setValue(this.totalMensalidade);
        this.preMatriculaForm.get('numParcelasMensalidade')?.setValue(pagamentoSelecionado.parcelasMaximas);
        this.preMatriculaForm.get('valorParcelasMensalidade')?.setValue(pagamentoSelecionado.valorParcela);
        this.preMatriculaForm.get('formaDePagamentoMensalidades')?.setValue(pagamentoSelecionado.contaParcelaTipoPagamento);

        break;
      case 2:
        this.pagamentoMaterialDidaticoSelecionado = true;

        this.materialDidaticoFinalParcela = pagamentoSelecionado.valorParcela;
        this.descontoMaterialDidatico = pagamentoSelecionado.valorComDesconto;
        this.materialDidaticoParcela = ((this.materialDidaticoFinalParcela * pagamentoSelecionado.parcelasMaximas) + this.descontoMaterialDidatico) / pagamentoSelecionado.parcelasMaximas;
        this.percentualDescontoMaterialDidatico = `${pagamentoSelecionado.desconto}%`;
        this.qtdeParcelasMaterialDidaticoSelecionada = pagamentoSelecionado.parcelasMaximas;
        this.totalMaterialDidatico = pagamentoSelecionado.parcelasMaximas * pagamentoSelecionado.valorParcela;

        this.preMatriculaForm.get('totalMaterialDidatico')?.setValue(this.totalMaterialDidatico);
        this.preMatriculaForm.get('numParcelasMaterialDidatico')?.setValue(pagamentoSelecionado.parcelasMaximas);
        this.preMatriculaForm.get('valorParcelasMaterialDidatico')?.setValue(pagamentoSelecionado.valorParcela);
        this.preMatriculaForm.get('formaDePagamentoLivro')?.setValue(pagamentoSelecionado.contaParcelaTipoPagamento);

        break;
    }

  }

  // Verifica se há condições de pagamento ativas para uma modalidade específica
  verificaCondicaoPagamentoModalidade(modalidade: number) {

    return this.turmaPreco?.turmaPrecoCondicaoPagamentos?.some((x: any) =>
      x.turmaPrecoCondicaoPagamentoModalidade === modalidade && x.ativa === true
    ) || false;

  }

  salvarPreMatricula() {

    this.isLoading = true;

    if (!this.preMatriculaForm.valid) {
      this.preMatriculaForm.markAllAsTouched();
      const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
              titulo: "Erro",
              mensagem: "Corrija os erros antes de submeter o formulário"
          }
      });

      this.isLoading = false;
      return;

    }


    let cpf = this.preMatriculaForm.get('pagadorCpf')?.value;
    let cep = this.preMatriculaForm.get('pagadorCep')?.value;
    let telefone = this.preMatriculaForm.get('pagadorTelefone')?.value;
    this.preMatriculaForm.get('pagadorCpf')?.setValue(this.filtraApenasNumeros(cpf));
    this.preMatriculaForm.get('pagadorCep')?.setValue(this.filtraApenasNumeros(cep), {emitEvent: false});
    this.preMatriculaForm.get('pagadorTelefone')?.setValue(this.filtraApenasNumeros(telefone));

    this.preMatriculaForm.get('saguiClienteId')?.setValue(this.turma.saguiClienteId);
    this.preMatriculaForm.get('anoLetivoId')?.setValue(this.turma.anoLetivoId);

    if (!this.preMatriculaForm.value.ciente) {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
                titulo: "Erro",
                mensagem: "Você deve aceitar os termos para continuar com a Pré Matrícula"
            }
        });

        return;
    };

    this.preMatriculaService.salvarPreMatricula(this.preMatriculaForm.value).subscribe({
      next: (data) => {
        this.isLoading = false;

        this.preMatricula = data.body.preMatricula;
        this.getNetSellerId = data.body.getNetSellerId;

        // se devolver preMatricula com status de processoFinalizado (caso valorMatricula = 0) nem abre getnet
        if(this.preMatricula?.preMatriculaStatus === 1) {

          this._snackBar.open("Registro salvo com sucesso", "", {
            duration: 3000, // tempo em milissegundos (aqui 3 segundos)
          });
          
          this.fecharDialog();
          return;
        }

        this.apiGetNet.amount = this.preMatriculaForm.value.valorMatricula.toFixed(2);

        this.apiGetNet.token = data.body.token;

        this.apiGetNet.orderid = this.preMatricula.contaParcelaId;

        var nomeArray = this.preMatricula.pagadorNome.split(" ");

        this.apiGetNet.firstname = nomeArray[0];

        this.apiGetNet.lastname = nomeArray[nomeArray.length - 1];

        this.apiGetNet.installments = this.preMatriculaForm.get('numParcelasMatricula')?.value > 0 ?
          this.preMatriculaForm.get('numParcelasMatricula')?.value : 1;

        // metodos de pagamentos desabilitados no getnet
        this.apiGetNet.paymentMetohodsDisabled = '["debito", "pix"]';

        // this.apiGetNet.items = '[{"name": "Matrícula 2023", "description": "Matrícula 2023","value": ' + data.body.valorMatricula.toFixed(2) + ',"quantity": 1,"sku": ""}]';
        this.apiGetNet.items = JSON.stringify([{
          name: `Matrícula ${this.IRematricula.anoLetivo}`,
          description: this.turmaPreco.descricao,
          value: Number(data.body.valorMatricula.toFixed(2)),
          quantity: 1,
          sku: ""
        }]);

        let dateVencimento = new Date();
        dateVencimento.setDate(dateVencimento.getDate() + 2);

        var isFound = false;

        var scripts = document.getElementsByTagName("script");

        for (var i = 0; i < scripts.length; ++i) {
            if (scripts[i].getAttribute('src')?.includes("loader")) {
                isFound = true;
            }
        };

        // remove script antigo e e recria. Se não tiver antigo ele só cria
        let oldScript = document.querySelector("script[src*='loader']");
        if (oldScript) {
          oldScript.remove();
        }

        let node = document.createElement('script');
        node.src = this.getNetScript; // alterar pra usar script de homolog?
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        node.setAttribute("data-getnet-sellerid", this.getNetSellerId);
        node.setAttribute("data-getnet-button-class", "pay-button-getnet");
        node.setAttribute("data-getnet-token", "Bearer " + this.apiGetNet.token);
        node.setAttribute("data-getnet-amount", this.apiGetNet.amount);
        node.setAttribute("data-getnet-payment-methods-disabled", this.apiGetNet.paymentMetohodsDisabled);
        node.setAttribute("data-getnet-orderid", this.apiGetNet.orderid);
        node.setAttribute("data-getnet-installments", this.apiGetNet.installments);
        node.setAttribute("data-getnet-customer-first-name", this.apiGetNet.firstname);
        node.setAttribute("data-getnet-customer-last-name", this.apiGetNet.lastname);
        node.setAttribute("data-getnet-customer-document-type", "CPF");
        node.setAttribute("data-getnet-customer-document-number", this.preMatricula.pagadorCpf);
        node.setAttribute("data-getnet-customer-country", "Brasil");
        node.setAttribute("data-getnet-items", this.apiGetNet.items);
        node.setAttribute("data-getnet-customerid", this.preMatricula.responsavelClienteId.toString());
        node.setAttribute("data-getnet-customer-email", this.preMatricula.pagadorEmail);
        node.setAttribute("data-getnet-customer-address-street", this.preMatricula.pagadorLogradouro);
        node.setAttribute("data-getnet-customer-address-street-number", this.preMatricula.pagadorLogradouroNumero);
        node.setAttribute("data-getnet-customer-address-complementary", this.preMatricula.pagadorLogradouroComplemento);
        node.setAttribute("data-getnet-customer-address-neighborhood", this.preMatricula.pagadorBairro);
        node.setAttribute("data-getnet-customer-address-city", this.preMatricula.pagadorMunicipio);
        node.setAttribute("data-getnet-customer-address-state", this.preMatricula.pagadorUf);
        node.setAttribute("data-getnet-customer-address-zipcode", this.preMatricula.pagadorCep);
        node.setAttribute("data-getnet-boleto-expiration-date", this.formatDate(dateVencimento));

        this.renderer.appendChild(document.body, node);

        setTimeout(() => { this.getNetButton.nativeElement.click(); }, 1000);
        this.registrarEventoGetNet();
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: "Erro ao Salvar Pré-Matrícula.",
            erro: error
          }
        });
      }
    });
  }

  filtraApenasNumeros(texto: string){
    return texto.replace(/[\D]/g, "");
  }

  verificaSeEhNumero(texto: string) {
    return /^\d*$/.test(texto);
  }

  padTo2Digits(num: any) {
    return num.toString().padStart(2, '0');
  }

  formatDate(date: any) {
    return [
      this.padTo2Digits(date.getDate()),
      this.padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join('/');
  }

  registrarEventoGetNet() {

      if (window.addEventListener) {
          window.addEventListener("message", this.eventoGetNet, false);
      } else {
          (<any>window).attachEvent("onmessage", this.eventoGetNet);
      }
  }

  eventoGetNet: any = (event: any) => {

    var data = event.data || '';

    switch (data.status || data) {
      // Corfirmação positiva do checkout.
      case 'success':

        this.preMatricula.preMatriculaStatus = 1;
        // atualiza conta da parcela para ativo pois callback que ira quitar
        this.atualizaStatusContaParcela(this.preMatricula.contaParcelaId, 0);
        this.atualizaPreMatricula(data);

        console.log('Transação realizada.');
        break;

      // Notificação de que o IFrame de checkout foi fechado a aprovação.
      case 'close':
        console.log('Checkout fechado.');

        // se processo finalizado (boleto registrado ou cartao aprovado) fecha dialog
        if(this.processoFinalizado === true)
          this.fecharDialog();
        break;

      // Notificação que um boleto foi registrado com sucesso
      case 'pending':

        this.preMatricula.preMatriculaStatus = 1;
        this.atualizaPreMatricula(data);

        console.log('Boleto registrado e pendente de pagamento');
        break;

      // Notificação que houve um erro na tentativa de pagamento
      case 'error':

        this.preMatricula.preMatriculaStatus = 2;
        this.atualizaStatusContaParcela(this.preMatricula.contaParcelaId, 5); // atualiza conta da parcela para 5 (erro pagamento)
        this.atualizaPreMatricula(data);

        console.warn(data.detail.message);
        break;

      // Ignora qualquer outra mensagem
      default:
        break;
    }
  }

  atualizaPreMatricula(status: any) {
    this.preMatriculaService.put(this.preMatricula).subscribe((data: any) => {


      let dialogTitle = "";
      let dialogMessage = "";
      switch (status.status || status) {
        case 'success':

          dialogTitle = "Sucesso";
          dialogMessage = "Pré Matrícula Realizada com Sucesso.";
          this.processoFinalizado = true;
          break;

        case 'pending':
          dialogTitle = "Sucesso";
          dialogMessage = "Pré Matrícula Realizada com Sucesso.";
          this.processoFinalizado = true;
          break;

        case 'error':
          dialogTitle = "Error";
          dialogMessage = "Ocorreu um erro na forma de pagamento escolhida. Altere a forma de pagamento e tente novamente.";
          this.processoFinalizado = false;
          break;
      }

      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: dialogTitle,
          mensagem: dialogMessage
        }
      });

    }, (error: HttpErrorResponse) => {

      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: "Erro ao Atualizar Pré-Matrícula.",
          erro: error
        }
      });
    });
  }

  atualizaStatusContaParcela(idContaParcela: number, status: number) {
    this.preMatriculaService.putPreMatriculaContaParcelaStatus(idContaParcela, status).subscribe((data: any) => {
      console.log('Status da conta da parcela atualizado com sucesso.');
    }, (error: HttpErrorResponse) => {
      console.error('Erro ao atualizar status da conta da parcela:', error);
    });
  }

  // Verifica se a cobrança está habilitada para o tipo informado referente ao turmaPreco selecionado
  verificaCobrancaHabilitada(tipoCobranca: number) {

    // 0 - matricula, 1 - Mensalidade , 2 - Material Didatico
    switch (tipoCobranca) {
      case 0:
        return !this.turmaPreco?.matriculaDesabilitarCobranca;
      case 1:
        return !this.turmaPreco?.mensalidadeDesabilitarCobranca;
      case 2:
        return !this.turmaPreco?.materialDidaticoDesabilitarCobranca;
      default:
        return false;
    }
  }

  preenchePagadorComDadosResponsavelFinanceiro(){
    //busca responsavel financeiro e seta no form
    this.preMatriculaService.consultarResponsavelFinanceiroPorAlunoId(this.IRematricula.alunoId).subscribe(data => {
      //preenche campos "pagador" com dados do responsavel financeiro
      this.preMatriculaForm.get('pagadorNome')?.setValue(data.body.nomeFantasia);
      this.preMatriculaForm.get('pagadorCpf')?.setValue(data.body.cpf);
      this.preMatriculaForm.get('pagadorEmail')?.setValue(data.body.email);
      this.preMatriculaForm.get('pagadorLogradouro')?.setValue(data.body.logradouro);
      this.preMatriculaForm.get('pagadorLogradouroNumero')?.setValue(data.body.numero);
      this.preMatriculaForm.get('pagadorLogradouroComplemento')?.setValue(data.body.complemento);
      this.preMatriculaForm.get('pagadorBairro')?.setValue(data.body.bairro);
      this.preMatriculaForm.get('pagadorCep')?.setValue(data.body.cep);
      this.preMatriculaForm.get('pagadorTelefone')?.setValue(data.body.telefone);
      this.preMatriculaForm.get('pagadorMunicipioId')?.setValue(data.body.municipioId);
      this.preMatriculaForm.get('pagadorUfId')?.setValue(data.body.ufId);
      this.preMatriculaForm.get('pagadorPaisId')?.setValue(data.body.paisId);


    }, (error: HttpErrorResponse) => {

      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: "Erro ao buscar Responsável Financeiro.",
          erro: error
        }
      });
    });
  }

}
